import { handleActions } from "redux-actions";
import invoicesActions from "./actions";

const initialState = {
  list: [],
  chargebeeList: [],
  chargebeeCreditNotesList: [],
  count: 0,
  currentPage: 0,
  source: "db", // "db" or "chargebee" or "chargebee_cn"
};

export default handleActions(
  {
    [invoicesActions.GET_INVOICES_SUCCESS]: (state, action) => ({
      ...state,
      list: action.payload.invoices || [],
      count: action.payload.count || 0,
    }),
    [invoicesActions.GET_CHARGEBEE_INVOICES_SUCCESS]: (state, action) => ({
      ...state,
      chargebeeList: action.payload.invoices || [],
    }),
    [invoicesActions.GET_CHARGEBEE_CREDIT_NOTES_SUCCESS]: (state, action) => ({
      ...state,
      chargebeeCreditNotesList: action.payload.credit_notes || [],
    }),
    [invoicesActions.CURRENT_PAGE]: (state, action) => ({
      ...state,
      currentPage: action.payload,
    }),
    [invoicesActions.SET_SOURCE]: (state, action) => ({
      ...state,
      source: action.payload,
      currentPage: 0,
    }),
  },
  initialState
);